<template>
  <div v-show="active" :id="id" class="tab-content">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped></style>
